/*
 * @Author: FengXiao
 * @Date: 2020-07-02 15:20:31
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-13 23:04:20
 */
import { checkEquipment } from '@/utils';
import store from '@/store/index.js';

export default {
  install(Vue, router) {
    const list = [];
    router.options.routes.forEach(item => {
      if (item.meta && item.meta.keepAlive === false) {
        list.push(item.name);
      }
    });
    window.$store.commit('setExcludeRouters', list.join());
    router.beforeEach((to, from, next) => {
		if(to.path == "/yixi_international" || to.path == "/bindmobile") {
			store.state.international_show = true;
			next();
		}else {
			store.state.international_show = false;
			next();
		}
      if (checkEquipment()) {
        next();
      }
    });
    /* router.afterEach((to, from) => {
    }); */
  },
};
